import { ILayoutFilter } from '@base/@types/components/Layout/Filters'

export const reportFilter: ILayoutFilter[] = [
  {
    id: 'anosIds',
    label: 'Ano',
    type: 'checkbox'
  },
  {
    id: 'anosSelectIds',
    label: '',
    filterId: 'yearBudget',
    type: 'select',
    isMulti: true
  },
  {
    id: 'mesesIds',
    label: 'Mês',
    type: 'checkbox'
  },
  {
    id: 'mesesSelectIds',
    label: '',
    filterId: 'monthBudget',
    type: 'select',
    isMulti: true
  },
  {
    id: 'fatorIds',
    label: 'Historico',
    type: 'checkbox'
  },
  {
    id: 'fatorSelectIds',
    label: '',
    filterId: 'historicBudget',
    type: 'select',
    isMulti: true
  }
]
